import { GET } from "shared/xhr";

const API_URL = process.env.REACT_APP_API_URL;

export const getIsSupplementaryCardholder = async () => {
  try {
    const data = await GET(`${API_URL}/is-supplementary-cardholder`);
    return data;
  } catch (error) {
    throw error;
  }
};
